module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0699-min.06ddacea.jpg";